import { Injectable, ElementRef } from "@angular/core";
import { HeaderHolderInfo } from "../models/domains/features/header-holder-info";

@Injectable({ providedIn: "root" })
export class HeaderService {
  constructor() {}

  setTitleText(titleText: string): void {
    HeaderHolderInfo.setTitleText(titleText);
  }

  setTitleIcon(titleIcon: string): void {
    HeaderHolderInfo.setTitleIcon(titleIcon);
  }

  getTitleText(): string {
    return HeaderHolderInfo.getTitleText();
  }

  getTitleIcon(): string {
    return HeaderHolderInfo.getTitleIcon();
  }
}
